import React from "react";
import ProgressBarChart from "./ProgressBarChart";

const ItemFocus = (props) => {
    const { item, linkage } = props;

    const filteredItems = item.focus
    .filter((f) => ['category', 'location', 'industry'].includes(linkage.focus)
        ? f.value !== item.value
        : f.value !== item.value && linkage.parent_value === f.groupvalue);

    return (
        <React.Fragment>
            <div className="label-heading">Core services</div>
            <div className="py-2 mb-3 px-3 mb-lg-0 border">
                <div style={{ color: "#43128E" }} className="text-sm fw-bold">{`${item.percent}%  ${item.label}`}</div>
                <ProgressBarChart key={item.title} items={[ {label: item.label, percent: item.percent }, ...filteredItems]} />
            </div>
        </React.Fragment>
    )
}

export default ItemFocus